import { useQuery } from '@tanstack/react-query'
import { listOfPublicVideoTalents } from '../../../services/HutritClub'
import Wrapper from '../../../components/Wrapper/Wrapper'
import VideoTalentCard from '../ListOfVideoTalents/components/VideoTalentCard/VideoTalentCard'
import InfiniteScroll from 'react-infinite-scroll-component'
import { useEffect, useState } from 'react'
import profiles_verify from '../icons/profiles_verify.svg'
import useResize from '../../../hooks/useResize'
import { OUT_OF_THE_APP, VIEWPORT_LG } from '../../../utils/constants'
import { useTranslation } from 'react-i18next'
import DashboardWrapper from '../../Dashboard/components/DashboardWrapper'
import hutrit_club_icon from '../icons/already_hutrit_club_member_company.svg'
import Divider from '../../../components/Divider'

const PublicModule = () => {
  const { t } = useTranslation()
  const viewportSize = useResize()
  const isMobile = viewportSize[0] <= VIEWPORT_LG
  const [page, setPage] = useState(0)
  const [hasMore, setHasMore] = useState(true)
  const [listTalents, setListTalents] = useState([])

  const { data: listOfPublicVideoTalentsData, isSuccess } = useQuery(
    ['list-public-video-talents', page],
    () => listOfPublicVideoTalents({ page })
  )

  useEffect(() => {
    if (isSuccess) {
      if (
        !listOfPublicVideoTalentsData?.list?.length ||
        listOfPublicVideoTalentsData?.list?.length === 0
      ) {
        setHasMore(false)
        return
      }

      setListTalents((prev) => [...prev, ...listOfPublicVideoTalentsData.list])
    }
  }, [isSuccess, listOfPublicVideoTalentsData])

  return OUT_OF_THE_APP ? (
    <Wrapper activeFooter={false} staticNavbar renderGreen={false}>
      <div className="d-flex flex-column align-items-center justify-content-center mt-5">
        <span
          className={`${
            isMobile ? 'fontSize14' : 'fontSize32'
          } text-on-bg-primary fw-bolder text-center`}
        >
          Explora nuestros{' '}
          <strong className="text-illustration">talentos</strong>
        </span>
        <span
          className={`${
            isMobile ? 'fontSize12' : ''
          } text-on-bg-primary text-center`}
          style={{
            opacity: '0.5',
          }}
        >
          Todos los perfiles han sido verificados por Hutrit. Revisa sus vídeos
          de presentación y conecta con los <br className="d-lg-flex d-none" />{' '}
          talentos que encajen con lo que necesitas.
        </span>
        <img src={profiles_verify} width={200} height={28} className="mt-3" />
        <InfiniteScroll
          className="mt-5 container gap-4"
          dataLength={listTalents?.length}
          next={() => setPage((prev) => prev + 1)}
          hasMore={hasMore}
          loader={<h4>{t('charging')}...</h4>}
          endMessage={
            <p className="text-center font-medium text-muted-foreground mt-3">
              <b>Ya viste todo 🎉</b>
            </p>
          }
        >
          <div className="row justify-content-center g-3">
            {listTalents?.map((talent) => {
              return (
                <div key={talent?.id} className="col-12 col-sm-6 col-md-3">
                  <VideoTalentCard
                    key={talent?.id}
                    talentId={talent?.talent?.id}
                    username={talent?.talent?.user?.username}
                    videoUrl={talent?.url}
                    talen_skills={talent?.talent?.talen_skills}
                    description={talent?.description}
                  />
                </div>
              )
            })}
          </div>
        </InfiniteScroll>
      </div>
    </Wrapper>
  ) : (
    <DashboardWrapper dashboardWrapperClassName='pt-5 mt-5'>
      <header className="d-flex justify-content-between align-items-center">
        <div className="d-flex align-items-center gap-4">
          <h1 className="text-on-bg-primary fw-bolder">Talento</h1>{' '}
          <img
            src={hutrit_club_icon}
            width={viewportSize[0] <= VIEWPORT_LG ? 150 : 150}
          />
        </div>
      </header>
      <Divider className="w-100 bg-on-bg-primary mb-1 mt-4 d-none d-lg-flex" />
      <div className="d-flex flex-column align-items-center justify-content-center">
        <InfiniteScroll
          className="mt-5 container gap-4"
          dataLength={listTalents?.length}
          next={() => setPage((prev) => prev + 1)}
          hasMore={hasMore}
          loader={<h4>{t('charging')}...</h4>}
          endMessage={
            <p className="text-center font-medium text-muted-foreground mt-3">
              <b>Ya viste todo 🎉</b>
            </p>
          }
        >
          <div className="row justify-content-center g-3">
            {listTalents?.map((talent) => {
              return (
                <div key={talent?.id} className="col-12 col-sm-6 col-md-4">
                  <VideoTalentCard
                    talentId={talent?.talent?.id}
                    username={talent?.talent?.user?.username}
                    videoUrl={talent?.url}
                    talen_skills={talent?.talent?.talen_skills}
                    description={talent?.description}
                  />
                </div>
              )
            })}
          </div>
        </InfiniteScroll>
      </div>
    </DashboardWrapper>
  )
}

export default PublicModule
